import { BrandModel } from "../frame/BrandModel.js";
export { SidebarModel, SubmenuModel };
/**
 * Модель боковой панели.
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
class SidebarModel {
  brand = new BrandModel({});
  menu = [];
  navbar = null;
  is_open = false;
  is_mobile = true;
  onToggle = (event) => { event.preventDefault(); };
  onClickMenuItem = (event) => { event.preventDefault(); };
  onSignOut = () => { };
  constructor(props) { Object.assign(this, props); }
}
class SubmenuModel {
  name = "SubmenuModel.name";
  icon = "question";
  child = [];
  is_open = false;
  onToggle = (event) => { event.preventDefault(); };
  constructor(props) { Object.assign(this, props); }
}
